import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, countryActionId, RecommendationTypeActionId, visitorRegistrationLink, delegateRegistrationLinkUrl } from "../../../utils/constants"
import { getItenaryUser_action, insertUpdateItineraryNote_action, getItineraryNoteDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/itenary_user_action"
import { getB2bScheduleList_action, removeB2bMeeting_action, updateB2bStatus_action, addB2bPersonalNotes_action } from "../../../actions/delegate_module_action/my_schedule_action/my_schedule_action"
import { Link } from "react-router-dom";
import { fill_action } from '../../../actions/fillCombo_action'
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action"
import { getVisitorDashboard_action, getVisitorRegistrationCredentials_action, getCoordinatorVisitor_action, getVisitorBadge_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action"
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import moment from "moment";

class Delegate_dashboard extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States
        this.state = {
            isLoading: false,

            isCoordinator: false,
            CoordinatorID: '',
            delegateList: [],
            selectedID: '',
            isDelegateSelect: false,
            coordinatorFN: '',
            coordinatorLN: '',
            coordinatorDelegateRegistrationID: '',
            arrangeMentCount: '',
            B2BConfirmedMeetingCount: '',
            B2BPendingCount: '',
            SeminarCount: '',
            InvitationEventCount: '',
            circularCount: '',
            isItenaryAdded: false
        }
        this.getDrawerDetails = this.getDrawerDetails.bind(this)
        this.getDeleagateDashboard = this.getDeleagateDashboard.bind(this)
        this.getDelegateCredentials = this.getDelegateCredentials.bind(this)
        this.getVisitorBadge = this.getVisitorBadge.bind(this)
        this.copyToClipboard = this.copyToClipboard.bind(this)
        this.onCircularsClick = this.onCircularsClick.bind(this)
        this.getCoordinatorDelegate = this.getCoordinatorDelegate.bind(this)
        this.onDelegateSelect = this.onDelegateSelect.bind(this)
        this.getFillList = this.getFillList.bind(this)
    }

    // On Component Load
    componentDidMount() {

        this.getDrawerDetails()
        this.getDelegateCredentials(0).then(() => {
            this.getFillList(RecommendationTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then((res) => {
                res.length > 0 && res.map(item => {
                    console.log(item.TypeName, JSON.parse(sessionStorage.getItem('loginDataSS')).AccountName)
                    if (item.TypeName == JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName) {
                        console.log(' item.TypeID', item.TypeID)
                        sessionStorage.setItem('typeID', item.TypeID)
                        this.getDeleagateDashboard()
                        this.getCoordinatorDelegate()
                        this.getItenaryUser()
                        this.getB2bMeetinList()
                    }
                })
            })

        })
    }

    getItenaryUser() {
        const { typeID, typeList, productAll, companyAll, countryAll } = this.state
        this.setState({ isLoading: true })

        return new Promise((resolve => {
            this.props.getItenaryUser_action(JSON.parse(sessionStorage.getItem('DelegateDataSS'))?.DelegateRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isItenaryAdded: data.data[2] ? data.data[2][0] ? data.data[2][0].ItenaryPath != '' && data.data[2][0].ItenaryPath != null && data.data[2][0].ItenaryPath != undefined ? true : false : false : false })
                        // this.setState({ isLoading: false })
                    }
                })
        }))
    }

    getB2bMeetinList() {
        const { typeID, typeList, productRecommendation, companyRecommendation, countryRecommendation, recommendationList } = this.state
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getB2bScheduleList_action(JSON.parse(sessionStorage.getItem('DelegateDataSS'))?.DelegateRegistrationID, 2)
                .then((data) => {
                    // this.setState({ RegistrationID: id })
                    if (data.error != 1) {
                        var b2bList = data.data[1] != undefined ? data.data[1].length > 0 ? data.data[1] : [] : data.data[0].length > 0 ? data.data[0] : []
                        var b2bmeet = 0
                        var invi = 0
                        for (var i = 0; i < b2bList.length; i++) {
                            if (b2bList[i].ArrangementType == "B2B Meeting") {
                                b2bmeet = b2bmeet + 1
                            }
                            if (b2bList[i].ArrangementType == "Invitation Event") {
                                invi = invi + 1
                            }
                        }
                        this.setState({ InvitationEventCount: invi, B2BConfirmedMeetingCount: b2bmeet })
                        // this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }

                }).catch((err) => {
                    console.log(err)
                    this.setState({ isLoading: false })
                    toastError(err.message || 'Something went wrong')
                })
        }))
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        return new Promise((resolve) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        // ExhibitionID
                        if (actionID === RecommendationTypeActionId) {
                            console.log("exhibitionStatusActionId", data.data)
                            this.setState({
                                typeList: data.data
                            })
                            resolve(data.data)
                        }
                    }
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data != null ? data.data : [],
                        })
                        resolve(true)
                    }
                })
        })
    }

    // Get Drawer Details
    getDrawerDetails() {
        this.setState({ isLoading: true })
        this.props.getDrawerDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getDrawerDetails", data.data)
                    sessionStorage.setItem("sessionVisitorDrawerData", JSON.stringify(data.data))

                    // Formatting Address
                    var address = data.data[0] != null && data.data[0] != "" && data.data[0]['Address'] != null && data.data[0]['Address'] != "" &&
                        data.data[0]['Address']
                    var addArray = address != "" && address != null && address.split(",")
                    sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray))

                    // Formating Mobile Numbers
                    var mobNo = data.data[0] != null && data.data[0] != "" && data.data[0]['MobileNo'] != null && data.data[0]['MobileNo'] != "" &&
                        data.data[0]['MobileNo']
                    var MobArray = mobNo != "" && mobNo != null && mobNo.split(",")
                    sessionStorage.setItem("FormatedMobNo", JSON.stringify(MobArray))
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // Get Exhibitior Details
    getDeleagateDashboard() {
        this.setState({ isLoading: true })
        this.props.getDelegateDashboard_action(this.state.isDelegateSelect)
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getExhibitorDashboard", data.data)
                    sessionStorage.setItem("drawerName", `${(data.data[0].PersonIncharge_FirstName)} ${(data.data[0].PersonIncharge_LastName)}`)
                    sessionStorage.setItem("sessionHeaderData", JSON.stringify(data.data))
                    sessionStorage.setItem("VisaApprovalLastDate", JSON.stringify(data.data[0].VisaApprovalLastDate))
                    sessionStorage.setItem("AccountTypeName", (data.data[0].AccountTypeName?.split(' ')[0]))
                    this.setState({
                        arrangeMentCount: data.data[0].ArrangementCount,
                        // B2BConfirmedMeetingCount: data.data[0].B2BConfirmedMeeting,
                        // B2BPendingCount: data.data[0].B2BPendingCount,
                        SeminarCount: data.data[0].SeminarCount,
                        // InvitationEventCount: data.data[0].InvitationEventCount,
                        circularCount: data.data[0].CicularCount ?? 0,
                        delegateUUID: data.data?.[0]?.UUID,
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // Get Exhibitior Details
    getCoordinatorDelegate() {
        this.setState({ isLoading: true })
        return new Promise((() => {
            this.props.getCoordinatorDelegate_action(this.state.coordinatorDelegateRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log("Get getCoordinatorDelegate_action", data.data[0])
                        // sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                        // if (data.data[0].isCoordinator) {
                        data.data.map(item => {
                            console.log('item.AccountID', item.AccountID, this.state.CoordinatorID)
                            if (item.AccountID == this.state.CoordinatorID) {
                                this.setState({ selectedID: item.AccountID })
                            }
                        })
                        this.setState({ delegateList: data.data })
                        // }
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    getDelegateCredentials(status) {
        this.setState({ isLoading: true })
        return new Promise((resolve => {
            this.props.getDelegateRegistrationCredentials_action(this.state.selectedID)
                .then((data) => {
                    if (data.error != 1) {
                        console.log("Get getDelegateCredentials", data.data[0], JSON.parse(sessionStorage.getItem('loginDataSS')))
                        status == 0 && sessionStorage.setItem('DelegateDataSS', JSON.stringify(data.data[0]))
                        status == 1 && sessionStorage.setItem('SelectedDelegateDataSS', JSON.stringify(data.data[0]))
                        sessionStorage.setItem('DelegateRegistrationID', JSON.stringify(data.data[0].DelegateRegistrationID))
                        if (status == 0 && data.data[0].isCoordinator) {
                            this.setState({ coordinatorFN: JSON.parse(sessionStorage.getItem('loginDataSS')).FirstName, coordinatorLN: JSON.parse(sessionStorage.getItem('loginDataSS')).LastName })
                            this.setState({ isCoordinator: true, CoordinatorID: data.data[0].DelegateRegistrationID, coordinatorDelegateRegistrationID: data.data[0].DelegateRegistrationID })
                        }
                        setTimeout(() => {
                            resolve(true)
                        }, 200);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    // Get Visitor Badge
    getVisitorBadge() {
        this.setState({ isLoading: true })
        this.props
            .getVisitorBadge_action(this.state.isDelegateSelect)
            .then((data) => {
                if (data != null) {
                    this.setState({ isLoading: false })
                    console.log('Report data : ', data);
                    var url;
                    url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError('There is some problem to download report. Please try again later!', {
                        theme: 'colored',
                        autoClose: 3000,
                        hideProgressBar: true,
                    })
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false })
            });
    }

    //Copy To ClipBoard Function
    copyToClipboard(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                console.log("Text Copy To ClipBoard")
            })
            .catch((err) => {
                console.log("Error Copying Text To Clipboard", err)
            })
    }

    // On Copy Click
    onCopyClick() {
        const copyText = visitorRegistrationLink
        this.copyToClipboard(copyText)
    }

    // On Circular Click
    onCircularsClick() {
        this.props.navigate('/exhCircularList', { state: { userFlag: 'Delegate', isDelegateSelect: this.state.isDelegateSelect, selectedID: this.state.selectedID, isCoordinator: this.state.isCoordinator } })
    }

    onDelegateSelect(AccountID) {
        const { isLoading, isCoordinator, delegateList, isDelegateSelect, selectedID } = this.state
        console.log(AccountID, 'selectedDelegate')
        if (AccountID != '') {
            this.props.navigate('/delegateForm', { state: { selectedVisitorID: AccountID } })
            // this.setState({ coordinatorVisitorRegistrationID: CoordinatorRegistrationID, isDelegateSelect: true }, () => {
            // this.getDelegateCredentials(1).then(() => {
            //     this.getDeleagateDashboard()
            //     this.setState({ isLoading: false })
            // })
            // })
        }
    }



    render() {
        const { isLoading, isCoordinator, delegateList, delegateUUID, InvitationEventCount, B2BConfirmedMeetingCount, B2BPendingCount, SeminarCount, selectedID, } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <VisitorHeader2 />
                <DelegateDrawer />
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container com-height" style={{ marginTop: '1rem', paddingBottom: '30px' }}>
                            <div className="">
                                <div className="width-dr-nav">
                                    <div className="row">
                                        <DelegateTopMenu />
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid px-2 px-md-4 pt-4 pb-0">

                                {/* Header Section */}
                                {sessionStorage.getItem('AccountTypeName') == 'Delegate' && <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
                                    <h5 className="mb-3 mb-md-0 fw-semibold">Delegate Management</h5>
                                    <div className="d-flex align-items-center">
                                        <button
                                            className="btn bg-white fw-semibold d-flex align-items-center mx-3"
                                            style={{ border: '1px solid #d1d5db', color: '#007062', fontSize: '14px', borderRadius: '4px' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigator.clipboard.writeText(`${delegateRegistrationLinkUrl}&${delegateUUID}`).then(() => {
                                                    toastSuccess('Link copied to clipboard!');
                                                }).catch(err => {
                                                    toastError('Failed to copy!', err);
                                                });
                                            }}
                                        >
                                            <i className="fa fa-files-o mx-1" style={{ fontSize: '16px' }}></i> Invite Delegate Link
                                        </button>
                                        <a target='_blank' href={`${delegateRegistrationLinkUrl}&${delegateUUID}`}>
                                            <button className="btn fw-semibold btn-aqua text-white px-3 d-flex align-items-center">
                                                Add Delegate
                                            </button>
                                        </a>
                                    </div>
                                </div>}

                                {/* KPI Cards Section */}
                                <div className="row mb-2">
                                    {/* Card 1: B2B Meetings */}
                                    <div className="col-md-3 mb-3 mb-md-0">
                                        <div className="card shadow-sm h-100 p-3 border" style={{ borderRadius: '10px', cursor: 'pointer' }}>
                                            <div className="d-flex justify-content-between align-items-center h-100" onClick={(e) => this.props.navigate('/mySchedule',)}>
                                                <div className="d-flex flex-column justify-content-center align-items-start">
                                                    <span className="text-muted fw-semibold mb-1" style={{ fontSize: '12px', textTransform: 'uppercase' }}>Interested List</span>
                                                    <h2 className="mb-0 text-dark fw-semibold" style={{ fontSize: '28px', lineHeight: '1' }}>{B2BConfirmedMeetingCount || 0}</h2>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: '50px', height: '50px', borderRadius: '8px', backgroundColor: '#e3edff', flexShrink: 0 }}>
                                                    <i className="fa fa-handshake-o" style={{ fontSize: '24px', color: '#007062' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card 2: Seminars */}
                                    <div className="col-md-3 mb-3 mb-md-0">
                                        <div className="card shadow-sm h-100 p-3 border" style={{ borderRadius: '10px', cursor: 'pointer' }}>
                                            <div className="d-flex justify-content-between align-items-center h-100" onClick={(e) => this.props.navigate('/mySchedule',)}>
                                                <div className="d-flex flex-column justify-content-center align-items-start">
                                                    <span className="text-muted fw-semibold mb-1" style={{ fontSize: '12px', textTransform: 'uppercase' }}>Conference Session</span>
                                                    <h2 className="mb-0 text-dark fw-semibold" style={{ fontSize: '28px', lineHeight: '1' }}>{SeminarCount || 0}</h2>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: '50px', height: '50px', borderRadius: '8px', backgroundColor: '#e3edff', flexShrink: 0 }}>
                                                    <i className="fa fa-television" style={{ fontSize: '24px', color: '#007062' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card 3: Invites Sent */}
                                    <div className="col-md-3 mb-3 mb-md-0">
                                        <div className="card shadow-sm h-100 p-3 border" style={{ borderRadius: '10px', cursor: 'pointer' }}>
                                            <div className="d-flex justify-content-between align-items-center h-100" onClick={(e) => this.props.navigate('/mySchedule',)}>
                                                <div className="d-flex flex-column justify-content-center align-items-start">
                                                    <span className="text-muted fw-semibold mb-1" style={{ fontSize: '12px', textTransform: 'uppercase' }}>Invitation</span>
                                                    <h2 className="mb-0 text-dark fw-semibold" style={{ fontSize: '28px', lineHeight: '1' }}>{InvitationEventCount || 0}</h2>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: '50px', height: '50px', borderRadius: '8px', backgroundColor: '#e3edff', flexShrink: 0 }}>
                                                    <i className="fa fa-envelope-o" style={{ fontSize: '24px', color: '#007062' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card 4: Itinerary Avg */}
                                    <div className="col-md-3">
                                        <div className="card shadow-sm h-100 p-3 border" style={{ borderRadius: '10px', cursor: 'pointer' }}>
                                            <div className="d-flex justify-content-between align-items-center h-100" onClick={(e) => this.props.navigate('/itenaryUser',)}>
                                                <div className="d-flex flex-column justify-content-center align-items-start">
                                                    <span className="text-muted fw-semibold mb-1" style={{ fontSize: '12px', textTransform: 'uppercase' }}>Itinerary added by Organizer</span>
                                                    <h2 className="mb-0 text-dark fw-semibold" style={{ fontSize: '28px', lineHeight: '1' }}>{this.state.isItenaryAdded ? 'Yes' : 'No'}</h2>
                                                </div>
                                                <div className="d-flex justify-content-center align-items-center" style={{ width: '50px', height: '50px', borderRadius: '8px', backgroundColor: '#e3edff', flexShrink: 0 }}>
                                                    <i className="fa fa-calendar-o" style={{ fontSize: '24px', color: '#007062' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Table Section */}
                                {sessionStorage.getItem('AccountTypeName') == 'Delegate' && <h6 className="mt-4 mb-3 fw-semibold" style={{ color: '#4a4a4a' }}>Delegate List</h6>}
                                {sessionStorage.getItem('AccountTypeName') == 'Delegate' && <div className="card shadow-none border-0 p-0 pt-0 mt-1 rounded-0 " style={{ borderRadius: '10px', overflow: 'hidden' }}>
                                    <div className="card-body p-0 pt-0">
                                        <div className="table-responsive ">
                                            <table className="table table-hover mb-0 border" style={{ fontSize: '13px' }}>
                                                <thead className="bg-light text-muted border-bottom border-top">
                                                    <tr>
                                                        <th className="border-top-0 fw-semibold px-4 py-3 text-center" style={{ fontSize: '12px', color: '#4a4a4a', width: '80px' }}>Sr no</th>
                                                        <th className="border-top-0 fw-semibold py-3" style={{ fontSize: '12px', color: '#4a4a4a' }}>Registration No</th>
                                                        <th className="border-top-0 fw-semibold py-3" style={{ fontSize: '12px', color: '#4a4a4a' }}>Delegate Name</th>
                                                        <th className="border-top-0 fw-semibold py-3" style={{ fontSize: '12px', color: '#4a4a4a' }}>Company Name</th>
                                                        <th className="border-top-0 fw-semibold py-3" style={{ fontSize: '12px', color: '#4a4a4a' }}>Designation</th>
                                                        <th className="border-top-0 fw-semibold py-3" style={{ fontSize: '12px', color: '#4a4a4a' }}>Registration Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {delegateList.length > 0 ? delegateList.map((item, i) => {
                                                        // Fallbacks for data
                                                        let fName = item.PersonIncharge_FirstName || 'harshal';
                                                        let lName = item.PersonIncharge_LastName || 'mohite';
                                                        let company = item.CompanyName || 'benchmark';
                                                        let role = item.PersonIncharge_Designation || 'DB Devloper';
                                                        let fullRegNo = item.DelegateRegistrationNo || `DEL/ITME2026/0013${2 + i}`;
                                                        let regDate = item.CreatedDate ? moment(item.CreatedDate).format("DD/MM/YYYY") : '07/08/2026';

                                                        return (
                                                            <tr key={item.AccountID || i} className="align-middle border-bottom" style={{ cursor: 'pointer', height: '50px' }} onClick={() => this.onDelegateSelect(item.AccountID)}>
                                                                <td className="px-4 text-dark align-middle text-center" style={{ fontSize: '13px' }}>
                                                                    {i + 1}
                                                                </td>
                                                                <td className="align-middle text-dark" style={{ fontSize: '13px' }}>
                                                                    {fullRegNo}
                                                                </td>
                                                                <td className="align-middle text-dark" style={{ fontSize: '13px' }}>
                                                                    {fName} {lName}
                                                                </td>
                                                                <td className="align-middle text-dark" style={{ fontSize: '13px' }}>
                                                                    {company}
                                                                </td>
                                                                <td className="align-middle text-dark" style={{ fontSize: '13px' }}>
                                                                    {role}
                                                                </td>
                                                                <td className="align-middle text-dark" style={{ fontSize: '13px' }}>
                                                                    {regDate}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }) : (
                                                        <tr><td colSpan="6" className="text-center py-5 text-muted">No Delegates Found</td></tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )
    }
}
export default withRouter(connect(null, { getDrawerDetails_action, getVisitorDashboard_action, getB2bScheduleList_action, getCoordinatorDelegate_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action, getCoordinatorDelegate_action, getItenaryUser_action, getDelegateDashboard_action, fill_action, getDelegateRegistrationCredentials_action })(Delegate_dashboard))


